class VerticalImageSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.vertical-slider__track');
    this.slides = Array.from(root.querySelectorAll('.vertical-slider__slide'));
    this.dots = Array.from(root.querySelectorAll('.vertical-slider__dot'));
    this.currentIndex = this.slides.findIndex((s) =>
      s.classList.contains('vertical-slider__slide--active')
    );
    if (this.currentIndex === -1) this.currentIndex = 0;

    this.isAnimating = false;
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
    this.autoplayTimer = null;

    // Mobile Swipe Coordinates Tracking
    this.touchStartY = 0;
    this.touchEndY = 0;

    this.bindEvents();
    this.bindTouchEvents(); 

    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
    }
  }

  bindEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        this.goToSlide(index);
        this.restartAutoplay();
      });
    });

    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

 bindTouchEvents() {
   
    if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) return;

    const slider = this.root;

    slider.addEventListener('touchstart', (e) => {
      this.touchStartY = e.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      const touchY = e.touches[0].clientY;
      const diff = this.touchStartY - touchY;
      if (Math.abs(diff) > 5) {
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    slider.addEventListener('touchend', (e) => {
      this.touchEndY = e.changedTouches[0].clientY;
      this.handleSwipe();
    }, { passive: false });
  }

  handleSwipe() {
    const swipeDistance = this.touchStartY - this.touchEndY;
    // Gesture threshold: 40px
    if (Math.abs(swipeDistance) > 40) {
      if (swipeDistance > 0) {
        // Swipe Up -> Next
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
      } else {
        // Swipe Down -> Prev
        const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(prevIndex);
      }
    }
    this.touchStartY = 0;
    this.touchEndY = 0;
  }

  goToSlide(newIndex) {
    if (this.isAnimating || newIndex === this.currentIndex || newIndex < 0 || newIndex >= this.slides.length) return;

    this.isAnimating = true;
    const currentSlide = this.slides[this.currentIndex];
    const targetSlide = this.slides[newIndex];
    const comingFromBelow = newIndex > this.currentIndex;

    targetSlide.style.transition = 'none';
    targetSlide.style.transform = comingFromBelow ? 'translateY(100%)' : 'translateY(-100%)';
    targetSlide.classList.remove('vertical-slider__slide--prev');
    void targetSlide.offsetHeight;
    targetSlide.style.transition = '';

    currentSlide.classList.remove('vertical-slider__slide--active');
    if (comingFromBelow) {
      currentSlide.classList.add('vertical-slider__slide--prev');
    } else {
      currentSlide.style.transform = 'translateY(100%)';
    }

    targetSlide.classList.add('vertical-slider__slide--active');
    targetSlide.style.transform = 'translateY(0)';
    this.updateDots(newIndex);

    const onTransitionEnd = () => {
      currentSlide.classList.remove('vertical-slider__slide--prev');
      currentSlide.style.transition = 'none';
      currentSlide.style.transform = 'translateY(100%)';
      void currentSlide.offsetHeight;
      currentSlide.style.transition = '';
      this.isAnimating = false;
      targetSlide.removeEventListener('transitionend', onTransitionEnd);
    };

    targetSlide.addEventListener('transitionend', onTransitionEnd);
    this.currentIndex = newIndex;
  }

  updateDots(activeIndex) {
    this.dots.forEach((dot, i) => {
      const isActive = i === activeIndex;
      dot.classList.toggle('vertical-slider__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

// Initialization Logic
function initVerticalSliders() {
  document.querySelectorAll('.vertical-slider').forEach((root) => {
    if (!root.dataset.initialized) {
      root.dataset.initialized = 'true';
      new VerticalImageSlider(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVerticalSliders);
} else {
  initVerticalSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.vertical-slider');
  if (root) {
    root.dataset.initialized = '';
    initVerticalSliders();
  }
});